var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root"},[_c('div',{staticClass:"tooltip-wrapper"},[_c('Transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tooltipVisible),expression:"tooltipVisible"}],ref:"tooltip",staticClass:"tooltip-content border",class:[
                     _vm.tooltipType,
                     _vm.instanceClasses,
                     {
                         'shadow-sm':!_vm.instanceClasses.includes('shadow'),
                         'p-2':!_vm.instanceClasses.includes('p-'),
                         'bg-dark text-light-light':!_vm.instanceClasses.includes('bg-'),
                         'rounded':!_vm.instanceClasses.includes('rounded'),
                         'border-dark':!_vm.instanceClasses.includes('border-')
                     }
                 ],style:({ zIndex: _vm.isInitalized ? 50 : -50 }),on:{"mouseenter":_vm.abortHide,"mouseleave":_vm.hideTooltip}},[_vm._t("default")],2)])],1),_vm._v(" "),_c('div',{ref:"trigger",staticClass:"tooltip-trigger",on:{"mouseenter":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[_vm._t("trigger")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }